import CtaLayout from '@components/CtaLayout';
import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import Notes from './components/Notes';
import OrderFooter from './components/OrderFooter';
import OrderHeader from './components/OrderHeader';
import OrderInfo from './components/OrderInfo';
import OrderItems from './components/OrderItems';
import OrderNote from './components/OrderNote';
import OrderProgress from './components/OrderProgress';
import useOrderLog from './hooks/useOrderLog';

interface Params {
    orderNo: string;
}

declare module '@stackflow/config' {
    interface Register {
        OrderLogActivity: Params;
    }
}

const OrderLogActivity: ActivityComponentType<'OrderLogActivity'> = ({ params }) => {
    const { orderNo } = params;
    const { orderLog, isLoading } = useOrderLog(orderNo);
    return (
        <AppScreen>
            {isLoading && (<Loading size='small'/>)}
            {orderLog && (
                <CtaLayout
                    header={<OrderHeader orderId={orderLog.orderId}/>}
                    footer={<OrderFooter orderLog={orderLog}/>}>
                    <OrderInfo orderLog={orderLog}/>
                    <OrderProgress orderStatus={orderLog.status}/>
                    <OrderNote/>
                    <OrderItems orderLog={orderLog}/>
                    <Notes order={orderLog}/>
                </CtaLayout>
            )}
        </AppScreen>
    );
};

export default OrderLogActivity;
